import ImageOne from "../../images/image1.jpg";
import ImageTwo from "../../images/image2.jpg";
import ImageThree from "../../images/image3.jpg";
import ImageFour from "../../images/image4.jpg";
import ImageFive from "../../images/image5.jpg";
import Snake from "../../images/Image6.jpg";
import Drum from "../../images/Drums.jpg";
import Cat from "../../images/cat.jpg";
import Dice from "../../images/dice.jpg";
import Rap from "../../images/Rapunzel.png";
import Machine from "../../images/machine.jpg";
import Dmagic from "../../images/dijstralogo.png";

export const portfolioData = [
  {
    sectionId: 2,
    projectName: "Owe-R",
    projectLink: "https://www.youtube.com/watch?v=vX3HCrVWw-g&t=17s", 
    image: ImageOne,
  },
  {
    sectionId: 2,
    projectName: "Keeper Clone",
    projectLink: "https://keepitinkeeper.netlify.app/", 
    image: ImageTwo,
  },
  {
    sectionId: 3,
    projectName: "Are You Cindrella",
    projectLink: "https://github.com/Ishum123/AreYouCindrella-", 
    image: Rap,
  },
  {
    sectionId: 6,
    projectName: "Queen's Estate Price Predictor",
    projectLink: "https://github.com/Ishum123/price_predictor", 
    image: Machine,
  },
  {
    sectionId: 4,
    projectName: "Magical-Dijkstra",
    projectLink: " https://dmagic.netlify.app/", 
    image: Dmagic,
  },
  {
    sectionId: 2,
    projectName: "Google Chrome Extension",
    projectLink: "https://www.youtube.com/watch?v=UHC33jBAces", 
    image: Cat,
  },
  {
    sectionId: 3,
    projectName: "Snake Charmer",
    projectLink: "https://www.youtube.com/watch?v=f80IPuki6-8", 
    image: Snake,
  },
  {
    sectionId: 3,
    projectName: "Set Your Day",
    projectLink: "https://github.com/Ishum123/set_your_day",
    image: ImageFour,
  },
 
  {
    sectionId: 4,
    projectName: "De-Code Huffy",
    projectLink: "https://github.com/Ishum123/De-Code-Huffy", 
    image: ImageFive,
  },
  {
    sectionId:  4,
    projectName: "Snake Game with Linked List",
    projectLink: "https://linked-snake.netlify.app/", 
    image: ImageThree,
  },
  {
    sectionId: 5,
    projectName: "DrumIt",
    projectLink: "https://ishum123.github.io/drums/", 
    image: Drum,
  },
  {
    sectionId: 5,
    projectName: "Ice-Dice",
    projectLink: "https://ishum123.github.io/ice-dices/", 
    image: Dice ,
  },
];

export const filterOptions = [
  {
    label: "All",
    id: 1,
  },
  {
    label: "Development",
    id: 2,
  },
  {
    label: "Python",
    id: 3,
  },
  {
    label: "DSA",
    id: 4,
  },
  {
    label: "Other Games",
    id: 5,
  },
  {
    label: "Machine Learning",
    id: 6,
  },
];
